enum AuthTypes {
	VALVONTA = "valvonta",
}

export default AuthTypes;
